export default __webpack_public_path__ + "static/media/logo-bug.f358e5a9864340f25bc153587fe84107.svg";